import * as React from "react";

function SvgIcons8Hubspot(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M7.5 4a2.5 2.5 0 000 5 2.5 2.5 0 001.332-.389l7.486 5.641A5.97 5.97 0 0015 18c0 1.552.594 2.96 1.56 4.025l-3.044 3.045A2 2 0 0013 25a2 2 0 000 4 2 2 0 001.93-2.516l3.209-3.209h.002A6 6 0 0027 18a5.997 5.997 0 00-5.001-5.91V8.73A2 2 0 0021 5a2 2 0 00-1 3.73v3.36a5.955 5.955 0 00-2.15.812L9.957 6.955A2.5 2.5 0 007.5 4zM21 15c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Hubspot);
